module.exports = __webpack_public_path__ + "img/image2.1f639488.png";